import React from "react";
import { Text, Spacer, List, Image, Subtitle } from "../dynamic.components";
import flowPath_image from "src/assets/images/process_control/flow_path.png";
import flowDirection_image from "src/assets/images/process_control/flow_direction.png";
import SubHotspots from "../Sub-hotspots";

export const Retentate_conent = () => (
  <>
    <Text text="The flow path is delivered in three separate sections for feed, retentate, and permeate" />
    <Subtitle subtitle="Retentate section" />
    <Text text="The retentate section has two inlets: one for buffers and one for product." />
    <Text text="A peristaltic pump transfers product and buffer to the recirculation bag." />
    <Text text="The pump can also be used for automated fed‑batch operation and diafiltration." />
    <Text text="An air sensor allows complete loading of sample and prevents air from entering the system." />
    <Text text="Two air filters are included:" />
    <List
      orderList={true}
      listArray={[
        "For filter integrity test.",
        "To filter air during sample recovery by air blow down.",
      ]}
    />
    <Text text="The retentate pressure control valve is used to control transmembrane pressure (TMP)" />
    <Subtitle subtitle="Feed section" />
    <Text text="The recirculation line has three inlets, for liquids for flushing, filter cleaning, and storage of the filter." />
    <Text text="The ÄKTA readyflux™ system’s recirculation pump is diaphragm type for low shear, and the single‑use pump head is integrated in the flow path." />
    <Text text="Pressure sensors are in the feed line and in the retentate line along with sensors for conductivity and temperature." />
    <Text text="Product can be recovered through the low‑point port." />
    <Subtitle subtitle="Permeate section" />
    <Text text="The permeate line includes sensors for pressure, conductivity, temperature, flow, UV, and pH (depending on flow kit) to control and monitor the filtration run." />
    <Text text="A peristaltic pump can be used for permeate flow control during microfiltration operation.  " />
    <Spacer x={2} />
  </>
);

export const FlowPath: React.FC = (): JSX.Element => {
  return (
    <>
      <div className="c-sidebar__body">
        <Text text="The flow kits include single‑use pump head and tubing, as well as sensors for pressure, conductivity, temperature, flow, UV, and pH (depending on the flow kit)." />
        <Text text="The flow kits are available with Tri‑Clamp connectors or with ReadyMate™ connectors for aseptic connection. The flow kit is supplied gamma irradiated. Flow kit with ReadyMate™ connectors are supplied with a sterile claim. The flow kit can be installed in less than 15 min using the installation wizard in UNICORN™ software." />
        <Spacer x={2} />
        <SubHotspots sublinkId="4-1" />
        <Text text="The flow path is delivered in two separate sections for feed and permeate" />

        <Subtitle subtitle="Feed line" />
        <Text text="The feed line has three inlets: one for buffers, one for product, and one for air." />
        <Text text="The feed pump is diaphragm type for low shear, and the single‑use pump head is integrated in the flow kit." />
        <Text text="The feed line includes pressure sensor to monitor the filtration run." />
        <Subtitle subtitle="Permeate line" />
        <Text text="The permeate line includes sensors for pressure, flow to control and monitor the filtration run." />
      </div>
    </>
  );
};
